import { Tab, Tabs as MuiTabs, TabsActions, TabsProps } from "@mui/material";
import { useEffect, useState } from "react";

export interface ContainedTabsProps {
  tabs: { label: string; activeColor?: string; color?: string; badge?: any }[];
  onChange?: (val?: number) => void;
  action?: React.Ref<TabsActions>;
  activeTab?: number;
  centered?: boolean;
  withBorder?: boolean;
  changeViaProps?: boolean;
  minWidth?: number;
  size?: 1 | 2 | 3;
  props?: TabsProps;
  styles?: {
    tab?: React.CSSProperties;
  };
}

export default function ContainedTabs(props: ContainedTabsProps) {
  const { centered, activeTab, withBorder, minWidth, styles } = props;
  const [value, setValue] = useState(activeTab || 0);
  useEffect(() => setValue(activeTab || 0), [activeTab]);
  const sizes = {
    1: [48, 4, 47, 40, 16],
    2: [36, 3, 35, 30, 14],
    3: [24, 2, 23, 20, 11],
  };
  const size = sizes[props.size || 1];

  function handleChange(e: React.SyntheticEvent, n: number) {
    !props.changeViaProps && setValue(n);
    props.onChange && props.onChange(n);
  }

  return (
    <div style={{ backgroundColor: "#EBEDF0", borderRadius: 6 }}>
      <MuiTabs
        value={value}
        onChange={handleChange}
        action={props.action}
        style={{
          borderBottom: "1px solid #dddddd",

          padding: `0px ${size[1]}px`,
          minHeight: size[0],
          borderRadius: 6,
          overflow: "unset",
        }}
        sx={{
          "& .MuiTabs-indicator": {
            height: size[3],
            backgroundColor: "#fff",
            borderRadius: "4px",
            // padding: size[1],
            top: size[1],
            ...(withBorder && {
              border: "1px solid",
              borderColor: "#1062D0",
            }),
          },
          "& .MuiTabs-scroller": {
            overflow: "unset !important",
          },
        }}
        centered={centered}
        scrollButtons={false}
        {...props.props}
      >
        {props.tabs.map((tab, index) => {
          return (
            <Tab
              key={index}
              disableRipple
              label={tab.label}
              icon={tab.badge}
              iconPosition="end"
              className={props.size ? "" : "text-xs md:text-base"}
              style={{
                zIndex: 2,
                minHeight: size[2],
                padding: 0,
                minWidth: minWidth || 24,
                fontWeight: 500,
                color: "#666",
                overflow: "unset",
                ...(styles?.tab || {}),
                ...(tab.activeColor &&
                  value === index && {
                    color: tab.activeColor,
                  }),
              }}
              sx={{
                fontSize: size[4],
              }}
            />
          );
        })}
      </MuiTabs>
    </div>
  );
}
